export enum ContentFieldTypes {
  FOOTER = 'footer',
  RESORT_LANDING_PAGE = 'resort-landing-page'
}
